/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Creem_Test_AmountInputs */

const en_admin_settings_fields_creem_test_amount = /** @type {(inputs: Admin_Settings_Fields_Creem_Test_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test amount (cents)`)
};

const zh_admin_settings_fields_creem_test_amount = /** @type {(inputs: Admin_Settings_Fields_Creem_Test_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试金额（分）`)
};

/**
* | output |
* | --- |
* | "Test amount (cents)" |
*
* @param {Admin_Settings_Fields_Creem_Test_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_creem_test_amount = /** @type {((inputs?: Admin_Settings_Fields_Creem_Test_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Creem_Test_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_creem_test_amount(inputs)
	return zh_admin_settings_fields_creem_test_amount(inputs)
});
export { admin_settings_fields_creem_test_amount as "admin.settings.fields.creem_test_amount" }